import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TooltipStatusService {
  private tooltipStatus = signal(false);

  setTooltipOpen(isOpen: boolean): void {
    this.tooltipStatus.set(isOpen);
  }

  getTooltipStatus(): boolean {
    return this.tooltipStatus();
  }
}
